import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NuveiCheckout } from '../../../../models/nuvei-checkout';
import { environment } from '../../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { takeWhile } from 'rxjs/operators';

declare var checkout: any;

@Component({
  selector: 'app-nuvei-checkout-modal',
  templateUrl: './nuvei-checkout-modal.component.html',
  styleUrls: ['./nuvei-checkout-modal.component.css']
})
export class NuveiCheckoutModalComponent implements OnInit, OnDestroy {

    alive: boolean;

    constructor(private translateService: TranslateService, public dialogRef: MatDialogRef<NuveiCheckoutModalComponent>, @Inject(MAT_DIALOG_DATA) public data: NuveiCheckout|undefined) {
      this.alive = false;
    }

    ngOnInit(): void {
      this.alive = true;

      this.dialogRef.beforeClose().pipe(takeWhile(() => this.alive)).subscribe((result) => {
        checkout.destroy();
      });

      //Open nuvei payment
      checkout({
        env: environment.production ? 'prod' : 'int',
        renderTo: '#secureContainer',
        //Credential
        sessionToken: this.data.SessionToken,
        merchantId: this.data.MerchantId,
        merchantSiteId: this.data.MerchantSiteId,
        //Money!
        currency: 'CAD',
        amount: this.data.Amount,
        //Basic setting
        country: 'CA',
        locale: this.translateService.currentLang,
        billingAddress: {
          country: 'CA',
          email: this.data.Email
        },
        //UI setting
        theme: 'tiles',
        cvvIcon: true,
        maskCvv: true,
        payButton: 'amountButton',
        showResponseMessage: false,
        autoOpenPM: true,
        alwaysCollectCvv: true,
        pmWhitelist: ['cc_card'],
        savePM: this.data.AllowCardSaving ? (this.data.ForceCardSaving ? 'always' : (this.data.DefaultCardSaving ? 'force' : true)) : false,
        onResult: this.onCallback()
      });
    }

    ngOnDestroy(): void {
      this.alive = false;
    }

    onCallback() {
      return (chkReturn: any) => {
        this.dialogRef.close({result: chkReturn, info: this.data });
      };
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/components/payment/nuvei-checkout/nuvei-checkout-modal/nuvei-checkout-modal.component.ts